<template>
  <div class="pa-thumbnail-image-crop-field" :class="additionalClass">
    <div class="attension">
      <p><font-awesome-icon icon="check" />画像を読み込みました。</p>
      <p>位置を微調整してください。</p>
      <p class="mini">(指でピンチすると拡大縮小できます。)</p>
    </div>

    <div class="pa-thumbnail-cropper-tools">
      <button
       class="button"
       :disabled="isDisabledRotation"
       @click.prevent="rotateImage(90)"
      >
        <font-awesome-icon icon="undo-alt" />
      </button>
      
      <button
       class="button"
       :disabled="isDisabledRotation"
       @click.prevent="rotateImage(-90)"
      >
        <font-awesome-icon icon="redo-alt" />
      </button>
    </div>

    <div class="pa-thumbnail-cropper" ref="changeThumbnailBoxView">
      <vue-croppie
        ref="croppieRef"
        :enableOrientation="croppieOptions.enableOrientation"
        :enableResize="croppieOptions.enableResize"
        :enableZoom="croppieOptions.enableZoom"
        :viewport="croppieOptions.viewport"
        :boundary="croppieOptions.boundary"
        :showZoomer="croppieOptions.showZoomer"

        @result="croppieResultEvent">
      </vue-croppie>

      <!-- <div class="pa-current-thumbnail-view" v-if="showPreview">
        <img v-bind:src="thumbnailUrl" />
        <div class="pa-thumbnail-overlay"></div>
        <div class="circle-view"></div>
      </div> -->

      <div class="pa-thumbnail-overlay" v-if="isLoadingThumbnail"></div>
    </div>

    <div class="pa-thumbnail-cropper-controls">
      <SetThumbnailButton
       :isLoading="isLoadingSetThumbnail"
       @onClick="handleClickSetThumbnail"
       :isDisabled="isDisabledSetThumbnailButton"
      />
    </div>
    
  </div>
</template>

<script>
import ThumbnailCropperMixins from '@/mixins/ThumbnailCropperMixins.js'
import SetThumbnailButton     from '@/components/Pages/Office/MessageApp/Additionals/ChangeThumbnail/SetThumbnailButton.vue'

export default {
  props   : {
    uploadFile  : {
      default: null
    },

    isDisabled : {
      default: false
    },

    isLoading : {
      default: false
    },
  },

  mixins  : [
    ThumbnailCropperMixins
  ],

  components : {
    SetThumbnailButton
  },

  data(){
    return {
      isLoadingSetThumbnail : false,
      isLoadingThumbnail    : false,

      additionalClass       : {
        'is-disabled' : false
      },

      isDisabledRotation            : false,
      isDisabledSetThumbnailButton  : false
    };
  },

  watch : {
    uploadFile : {
      handler(data){
        if(data === null) return;
        
        this.imageFile = data;
      },
      immediate: true
    },

    isDisabled : {
      handler(value){
        if(value === true){
          this.isDisabledRotation             = true;
          this.additionalClass['is-disabled'] = true;

          this.isDisabledSetThumbnailButton   = true;
          this.isLoadingThumbnail             = true;
        }else{
          this.isDisabledRotation             = false;
          this.additionalClass['is-disabled'] = false;
          
          this.isDisabledSetThumbnailButton   = false;
          this.isLoadingThumbnail             = false;
        }
      },
      immediate: true
    },

    isLoading : {
      handler(value){
        if(value === true){
          this.isLoadingSetThumbnail = true;
          this.isLoadingThumbnail    = true;
        }else{
          this.isLoadingSetThumbnail = false;
          this.isLoadingThumbnail    = false;
        }
      },
      immediate: true
    }
  },

  methods : {
    rotateImage(rotationAngle){
      if((this.showPreview === true) || (this.isLoadingThumbnail === true)) return;

      this.$refs.croppieRef.rotate(rotationAngle);
    },
    
    async handleClickSetThumbnail(){
      const base64Image = await this.croppieGetResultBase64();

      this.$emit('onSubmit', base64Image);
    }
  }
}
</script>

<style lang="scss">
@import "~croppie/croppie.css";
.pa-message-additionals{
  .pa-thumbnail-image-crop-field{
    .attension{
      width:100%;
      margin:.5rem auto;
      padding:.15rem 0 .2rem;
      
      background-color: #3ab686;
      color:#3f534a;
      border-radius: 4px;

      p{
        text-align: center;
        font-size:.8rem !important;
        margin-bottom:0;

        &.mini{
          font-size: .7rem !important;
          line-height:.8rem;
        }
      }

      svg{
        margin-right:.2rem;
      }
    }

    .pa-thumbnail-cropper-tools{
      margin-bottom:.4rem;
      margin:.4rem 0 .4rem;

      padding:0;
      display: flex;
      flex-direction: row;

      button.button{
        display:block;
        box-sizing: border-box;
        margin-bottom:0;
        margin:0 1%;
        padding:0;
        width:48%;
        text-align:center;
        border-radius: 4px;
        background-color: #cecece;
        border: 1px solid #d4d3d3;
        color:#666666;
      }
    }

    .pa-thumbnail-cropper{
      width:280px;
      height:280px;
      margin:0 auto;
      position:relative;
      overflow:hidden;

      .pa-current-thumbnail-view{
        width:280px;
        height:280px;
        margin:0 auto;
        border-radius:10px;
        position:relative;
        overflow:hidden;

        img{
          width:270px;
          height:270px;
          margin-top:5px;
          margin-left:5px;
        }

        .circle-view{
          position:absolute;
          top:5px;
          left:5px;
          width:270px;
          height:270px;
          border-radius:50%;
          border:2px solid #759593;
          -webkit-box-shadow: 0 0 2000px 2000px rgba(0, 0, 0, 0.5);
        }
      }

      .pa-thumbnail-overlay{
        position:absolute;
        top:0;
        left:0;
        width:280px;
        height:280px;
        background-color:#B5E2D2;
        z-index:2;
        opacity:.6;
      }

      .croppie-container .cr-viewport{
        border:2px solid #759593;
      }

      .cr-boundary{
        border-radius:10px;
      }
    }

    div.pa-thumbnail-cropper-controls{
      margin:.4rem 0 .4rem;
    }

    &.is-disabled{
      .attension{
        opacity:.8;
      }
    }
  }
}


.pa-message-set{
  &-default{
    .pa-message-additionals{
      .pa-thumbnail-image-crop-field{
        .attension{
          background-color: #3ab686;
          color:#3f534a;
        }

        .pa-thumbnail-cropper{
          .pa-current-thumbnail-view{
            .circle-view{
              border-color: #759593;
            }
          }

          .pa-thumbnail-overlay{
            background-color:#B5E2D2;
          }

          .croppie-container .cr-viewport{
            border-color:#759593;
          }
        }
      }
    }
  }

  &-lilica{
    .pa-message-additionals{
      .pa-thumbnail-image-crop-field{
        .attension{
          color:#653a68;
          background-color:#d7a1da;
        }

        .pa-thumbnail-cropper{
          .pa-current-thumbnail-view{
            .circle-view{
              border-color: #957595;
            }
          }

          .pa-thumbnail-overlay{
            background-color:#d5b5e2;
          }

          .croppie-container .cr-viewport{
            border-color:#957592;
          }
        }
      }
    }
  }
}
// background-color:#d7a1da;
</style>